import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { CBadge, CNavGroup, CNavItem } from '@coreui/react';

export const AppSidebarNav = ({ items = [] }) => {
  const location = useLocation();

  const LinkBody = (name, icon, badge, indent = false) => (
    <>
      {icon
        ? icon
        : indent && (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          )}
      {name}
      {badge && (
        <CBadge color={badge.color} className="ms-auto">
          {badge.text}
        </CBadge>
      )}
    </>
  );

  const Item = (item, index, indent = false) => {
    if (item.type === 'divider') {
      return <div key={`divider-${index}`} className="border-top my-1 opacity-50" />;
    }

    const { name, icon, badge, to, disabled } = item;
    if (!to) return null;

    return (
      <CNavItem key={index} disabled={disabled}>
        <NavLink className="nav-link" to={to} end>
          {LinkBody(name, icon, badge, indent)}
        </NavLink>
      </CNavItem>
    );
  };

  const Group = (item, index) => {
    const { name, icon, to, items: children = [] } = item;
    return (
      <CNavGroup
        key={index}
        idx={String(index)}
        compact
        toggler={LinkBody(name, icon)}
        visible={to ? location.pathname.startsWith(to) : false}
      >
        {children.map((child, i) =>
          child.items?.length ? Group(child, `${index}-${i}`) : Item(child, `${index}-${i}`, true),
        )}
      </CNavGroup>
    );
  };

  return <>{items.map((it, i) => (it.items?.length ? Group(it, i) : Item(it, i)))}</>;
};
